import {
  ActionTakenPayload,
  ButtonsPayloadInterface,
  From,
  MessageInterface,
  MessageType,
  TakeoverEventPayload,
  TakeoverEventType,
  TextPayloadInterface,
  VarKey
} from "@swivl-mono/types";

export function ConvertMessageToGPTLine(message: MessageInterface): string {
  let type;
  if (message.from && message.from) {
    if (message.from === From.USER) {
      type = "User";
    } else if (message.from === From.BOT) {
      type = "Bot";
    } else if (message.from === From.AGENT) {
      type = "Agent";
    }
  }

  if (!type) {
    return "";
  }

  if (message.type === MessageType.Text) {
    const payload: TextPayloadInterface = message.payload as any;
    return type + ": " + payload.text + "\n";
  } else if (message.type === MessageType.Buttons) {
    const payload: ButtonsPayloadInterface = message.payload as any;

    if (message.from && message.from && message.actionTaken) {
      const action = payload.actions.find((a) => (message && message.actionTaken ? a.id === message.actionTaken.target : false));
      if (action) {
        return "User : " + action.text + "\n";
      }
    }
  } else if (message.type === MessageType.TakeoverEvent) {
    const payload: TakeoverEventPayload = message.payload as any;
    if (payload.type === TakeoverEventType.TAKEOVER_STARTED) {
      return "Bot: Chat has been transferred to back to agent " + payload.agent?.name + " bot\n";
    } else {
      return "Bot: Chat has been transferred to back to the " + payload.agent?.name + " bot\n";
    }
  } else if (message.type === MessageType.ActionTaken) {
    const payload: ActionTakenPayload = message.payload as ActionTakenPayload;
    if (payload && payload.actionTaken && payload.actionTaken.data) {
      const data: any = payload.actionTaken.data;
      if (data[VarKey.LocationName]) {
        return "User: I select store " + data[VarKey.LocationName] + "\n";
      }
      if (data["name"]) {
        return "User: I select unit " + data["name"] + "\n";
      }
    }
  }

  return "";
}
